<template>
	<div>
		<h2>
			{{ $t('edit-filter') }}
			<div class="float-right">
				<button @click="save" class="btn btn-primary">{{ $t('save') }}</button>
			</div>
		</h2>	

		<div v-if="saved">
			<div class="alert alert-success mt-8">{{ $t('saved') }}</div>
		</div>

		<div class="row">
			<div class="col">

				<div class="form-group">
					<label>{{ $t('caption') }}</label>
					<input class="form-control" v-model="filter.caption" />
				</div>
			</div>
		</div>

	</div>
</template>

<script>
export default {
	components: {
	},
	data() {
		return {
			filter: {
				id: null,
				caption: null
			},
			saved: false
		}		
	},
	mounted() {
    	if(this.$route.params.filterid) {
    		this.getFilter(this.$route.params.filterid)
    	} else {
    		this.$store.commit("hideBlockingSpinner");
    	}
	},
	methods: {
		save() {
			this.$cfetch(`${this.$settings.APIBaseURL}/competencytests/filter/save`, {
				method: 'post',
				data: {
					competencytestfilter: this.filter
				}
			})
			.then((json) => {
				if (json.status == 'SUCCESS') {
					this.filter.id = json.filter.id;
					this.saved = true;
					setTimeout(() => {
						this.saved = false;
					}, 5000);						
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});			
		},		
		getFilter(id) {
  			this.$cfetch(`${this.$settings.APIBaseURL}/competencytests/filter/load`, {
  				data: {id}
  			})
			.then(json => {
				this.$store.commit("hideBlockingSpinner");
				if (json.status == 'SUCCESS') {

					this.filter = json.filter;


				}
			}).catch(error => {
				this.$store.commit("hideBlockingSpinner");
				this.$log.error.call(this, error);
			});			
		}
	},
	computed: {

	}
};
</script>